/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const featureId = feature.getID();
    const SERVO_PERIOD = feature.getSettingValue('SERVO_PERIOD');


    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    "SERVO_PERIOD": ${SERVO_PERIOD},
});`,
    });

    blocks.push({
        location: `var_${SERVO_PERIOD}_update`,
        blockType: BlockType.CODE,
        template: `var_${SERVO_PERIOD}_update_completed(simulator.context["${featureId}"]["SERVO_PERIOD"]);`,
    });

    blocks.push({
        location: `var_${SERVO_PERIOD}_set`,
        blockType: BlockType.CODE,
        template: `ioLineSet("${featureId}", "SERVO_PERIOD", value)`,
    });

    return blocks;
};
